import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import Dropzone from 'react-dropzone';

import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import { decimalFixed } from 'helper/unit-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import * as CostCodeActionTypes from '../../CostCodes/constants';
import * as WorkOrderActionType from '../../Work-Orders/constants';
// import * as ProjectActionType from 'Projects/constants';
import * as PurchaseOrderActionType from '../../Purchase-Orders/constants';
import * as PunchListActionType from '../constants';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import Translate from 'components/translate';

class AddPurchaseOrders extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    costCodeSelectList: PropTypes.array,
    userProfile: PropTypes.object,
    workOrderProfile: PropTypes.object,
    history: PropTypes.any,
    WorkOrderCredentials: PropTypes.any,
    // ProjectProfile: PropTypes.object,
    LotProfile: PropTypes.object
  };

  constructor(props) {
    super(props);

    let rfsId = null;
    let workOrderId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    if (props.match.params.WOID) {
      workOrderId = props.match.params.WOID;
    }

    this.state = {
      rfsId: rfsId,
      workOrderId: workOrderId,
      isCheckedSendCopy: false,
      isCheckedSendSubcontractor: true,
      isLoadingGetCostCodeSelectList: false,
      files: []
    };
  }

  componentDidMount() {
    this.fetWorkOrderById();
  }

  componentWillReceiveProps() {}

  fetWorkOrderById = () => {
    this.props.dispatch({
      type: PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_ASYNC,
      params: {
        punchListRefNo: this.state.rfsId,
        punchListItemRefNo: this.state.workOrderId
      }
      // callback: data => this.getProjectProfile(data)
    });

    // this.props.dispatch({
    //   type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
    //   params: {
    //     woRefNo: this.state.workOrderId,
    //     rfsRefNo: this.state.rfsId
    //   },
    //   callback: data => this.getProjectProfile(data)
    // });
  };

  // getProjectProfile = data => {
  //   this.props.dispatch({
  //     type: ProjectActionType.GET_PROJECT_BY_ID_ASYNC,
  //     params: data.requestDetail.project.id
  //   });
  // };

  fetchCostCodeSelectList = () => {
    this.setState({ isLoadingGetCostCodeSelectList: true });
    this.props.dispatch({
      type: CostCodeActionTypes.GET_COST_CODE_SELECT_LIST_ASYNC,
      callback: () => this.setState({ isLoadingGetCostCodeSelectList: false })
    });
  };

  onResetForm = () => {
    if (this.form) {
      this.form.resetForm(this.refs);
    }
  };

  onCheckedSendCopy = () => {
    this.setState({
      isCheckedSendCopy: !this.state.isCheckedSendCopy
    });
  };

  onCheckedSendSubcontractor = () => {
    this.setState({
      isCheckedSendSubcontractor: !this.state.isCheckedSendSubcontractor
    });
  };

  onSelectChange = (event, name) => {
    this.setState({ [name]: event.value });
  };

  hideLoading = () => {
    setTimeout(() => {
      PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
        isHideIndicator: true
      });
    }, 500);
  };

  onSubmit = e => {
    e.preventDefault();
    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: false
    });
    let isUploadAttachment = false;
    const formData = this.form.getValues();
    if (!isEmpty(this.state.files)) {
      isUploadAttachment = true;
    }
    formData.estimatedAmount = decimalFixed(formData.estimatedAmount);
    formData.actualAmount = decimalFixed(formData.actualAmount);
    formData.sendCopyEnabled = this.state.isCheckedSendCopy;
    formData.sendToSubcontractorEnabled = this.state.isCheckedSendSubcontractor;
    formData.workOrderRefNo = this.state.workOrderId;
    formData.issuedDate = new Date().toISOString();
    formData.costCode = this.state.costCode ? this.state.costCode.value : '';
    this.props.dispatch({
      type: PurchaseOrderActionType.CREATE_PURCHASE_ORDER_ASYNC,
      params: {
        data: formData,
        isUploadAttachment,
        rfsId: this.state.rfsId
      },
      callback: (data, status) => {
        if (status) {
          this.setupAWS(data);
        } else {
          this.hideLoading();
          this.props.history.push(
            `/punch-lists/punch-list-item/purchase-order/${this.state.rfsId}/${
              this.state.workOrderId
            }/detail/${data.refNo}`
          );
        }
      }
    });
  };

  setupAWS = data => {
    this.props.dispatch({
      type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
      params: { resourcePath: `purchase-order/${data.refNo}` },
      callback: () => {
        this.state.files.map(file => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
            params: {
              refNo: data.refNo,
              config: this.props.WorkOrderCredentials,
              file: file
            },
            callback: this.onUploadFileCallback(file.name)
          });
        });
      }
    });
  };

  onUploadFileCallback = fileName => (status, data) => {
    if (data.refNo) {
      this.uploadAttachmentsToServer(data, fileName);
    }
  };

  uploadAttachmentsToServer = (data, fileName) => {
    this.props.dispatch({
      type: PurchaseOrderActionType.PURCHASE_ORDER_ATTACHMENTS_ASYNC,
      params: {
        refNo: data.refNo,
        data: {
          url: data.data.Location,
          key: data.data.Key,
          fileName: fileName
        },
        rfsId: this.state.rfsId
      },
      callback: status => {
        this.hideLoading();
        if (status) {
          this.props.history.push(
            `/request-for-services/work-order/purchase-order/${
              this.state.rfsId
            }/${this.state.workOrderId}/detail/${data.refNo}`
          );
        } else {
          this.props.history.push(
            `/request-for-services/work-order/purchase-order/${
              this.state.rfsId
            }/${this.state.workOrderId}/detail/${data.refNo}?isEdit=true`
          );
        }
      }
    });
  };

  onDrop = e => {
    let newFiles = this.state.files;
    e.map(file => {
      file.uploadId = _.uniqueId();
      newFiles.push(file);
      this.setState({
        files: newFiles
      });
    });
  };

  deleteFile = index => {
    const files = this.state.files;
    files.splice(index, 1);
    this.setState({ files });
  };

  renderAttachment() {
    return (
      <div className='row col-sm-12'>
        <label>Attachment</label>
        <div>
          <Dropzone
            disableClick
            multiple={false}
            ref={node => {
              this.dropzoneRef = node;
            }}
            onDrop={this.onDrop}
            accept={['image/*', 'application/pdf']}
            style={{ position: 'initial' }}
          >
            {this.state.files.map((item, index) => (
              <div className='file-item' key={index}>
                <div>
                  <p className='item-name'>
                    {item.name} &nbsp;{' '}
                    <i
                      className='fa fa-trash ic-stop'
                      onClick={() => this.deleteFile(index)}
                    />
                  </p>{' '}
                </div>
              </div>
            ))}
            {isEmpty(this.state.files) && (
              <div className='files-bottom row col-sm-12'>
                <p>
                  <a
                    className='files-browse-txt cursor-pointer'
                    onClick={() => {
                      this.dropzoneRef.open();
                    }}
                  >
                    {' '}
                    + Add new attachment.
                  </a>
                </p>
              </div>
            )}
          </Dropzone>
        </div>
      </div>
    );
  }
  handleCancel = () => {
    this.props.history.push(
      `/request-for-services/work-order/detail/${this.state.rfsId}/${
        this.state.workOrderId
      }`
    );
  };

  costCodeItemTemplate = option => {
    if (!option.value) {
      return option.text;
    }
    return (
      <div className='ui-helper-clearfix'>
        <span>
          {option.extensionValue.name} ({option.extensionValue.code})
        </span>
      </div>
    );
  };

  costCodelabelTemplate = option => {
    return (
      <span>
        {option.extensionValue.name} ({option.extensionValue.code})
      </span>
    );
  };

  renderNewPurchaseOrder() {
    const disableSubmitButton = isEmpty(this.state.costCode);

    const { workOrderProfile } = this.props;

    if (isEmpty(workOrderProfile)) {
      return null;
    }

    if (isEmpty(workOrderProfile.requestDetail)) {
      return null;
    }

    const {
      workOrder: { woInformation }
    } = workOrderProfile;

    let projectCode = this.props.LotProfile.projectCode || '';
    if (this.form && this.form.getValues().projectCode) {
      projectCode = this.form.getValues().projectCode;
    }

    return (
      <div className='subcontractor box-form-siteone'>
        <div className='box-form-body'>
          <Form
            ref={ref => {
              this.form = ref;
            }}
            onSubmit={this.onSubmit}
          >
            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>
                    Cost center/account<span className='text-danger'> *</span>
                  </label>
                  <Input
                    value={projectCode}
                    type='text'
                    placeholder='Type in cost centers/accounts'
                    name='projectCode'
                    ref='projectCode'
                    className='form-control'
                    max='100'
                    maxLength='100'
                    errorMsg='Summary is maximum 100 characters'
                    validations={[Vali.required, Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>
                    Cost code <span className='text-danger'> *</span>
                  </label>
                  <Dropdown
                    onChange={ref => {
                      this.onSelectChange(ref, 'costCode');
                    }}
                    className='filestring-dropdown filter-dropdown'
                    onRemote={this.fetchCostCodeSelectList}
                    options={this.props.costCodeSelectList}
                    loading={this.state.isLoadingGetCostCodeSelectList}
                    optionLabel='text'
                    value={this.state.costCode}
                    showClear={true}
                    name='workOrderType'
                    placeholder='--Please select'
                    itemTemplate={this.costCodeItemTemplate}
                    labelTemplate={this.costCodelabelTemplate}
                    style={{ width: '100%', position: 'relative' }}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='col-lg-2 col-md-3 col-sm-4'>Issued to</div>
                  <div className='col-lg-10 col-md-9 col-sm-8'>
                    <strong>
                      {woInformation &&
                        woInformation.subcontractorProfile &&
                        woInformation.subcontractorProfile.companyName}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='row'>
                  <div className='col-sm-8'>
                    <div className='form-group'>
                      <label>
                        Estimated amount<span className='text-danger'> *</span>
                      </label>
                      <div style={{ position: 'relative' }}>
                        <span className='addon-input'>$</span>
                        <Input
                          style={{ paddingLeft: 20 }}
                          type='text'
                          name='estimatedAmount'
                          ref='estimatedAmount'
                          className='form-control'
                          max='12'
                          maxLength='12'
                          errorMsg='Estimated amount is maximum 12 characters'
                          validations={[
                            Vali.required,
                            Vali.maxlength,
                            Vali.isNumber
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-sm-6'>
                <div className='row'>
                  <div className='col-sm-8'>
                    <div className='form-group'>
                      <label>Actual amount</label>
                      <div style={{ position: 'relative' }}>
                        <span className='addon-input'>$</span>
                        <Input
                          style={{ paddingLeft: 20 }}
                          type='text'
                          name='actualAmount'
                          ref='actualAmount'
                          className='form-control'
                          maxLength='12'
                          max='12'
                          compare='estimatedAmount'
                          compareType='bigger'
                          compareErrorMsg='Estimated amount should be equal or greater than Actual amount.'
                          errorMsg='Actual amount is maximum 12 characters'
                          validations={[
                            Vali.maxlength,
                            Vali.compare,
                            Vali.isNumber
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-10'>
                <div className='form-group'>
                  <label>Reason for issuing PO</label>
                  <Textarea
                    className='form-control'
                    name='reason'
                    ref='reason'
                    max='500'
                    maxLength='500'
                    errorMsg='Reson for issuing PO is maximum 1000 characters'
                    style={{ height: 70 }}
                    validations={[Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-10'>
                <div className='form-group'>
                  <label>
                    Instruction<span className='text-danger'> *</span>
                  </label>
                  <Textarea
                    className='form-control'
                    name='instruction'
                    ref='instruction'
                    max='1000'
                    maxLength='1000'
                    errorMsg='Instruction is maximum 1000 characters'
                    style={{ height: 100 }}
                    validations={[Vali.required, Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='edit-po-label-inline '>Issued date</div>
                  <div className='edit-po-value-inline'>
                    <strong>{moment().format('MM/DD/YYYY')}</strong>
                  </div>
                </div>
              </div>

              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='edit-po-label-inline '>Issued by</div>
                  <div className='edit-po-value-inline'>
                    <strong>{this.props.userProfile.fullName}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Subcontractor invoice number</label>
                  <Input
                    type='text'
                    name='subcontractorInvoiceNumber'
                    ref='subcontractorInvoiceNumber'
                    className='form-control'
                    max='100'
                    maxLength='100'
                    errorMsg='Subcontractor invoice number is maximum 100 characters'
                    validations={[Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-12'>
                <div className='form-group'>{this.renderAttachment()}</div>
              </div>
            </div>

            <div
              className='form-group'
              style={{ marginTop: 15, display: 'flex' }}
            >
              <div style={{ marginRight: 20 }}>
                <a
                  className='btn btn-primary btn-siteone-default'
                  onClick={this.handleCancel}
                >
                  Cancel
                </a>
              </div>
              <div>
                <div>
                  <Submit
                    className='btn btn-primary btn-submit btn-siteone'
                    disabled={disableSubmitButton}
                  >
                    Create
                  </Submit>
                </div>
                <div style={{ marginTop: 10, borderLeft: '1px solid #d9d9d9' }}>
                  <div>
                    <CheckBoxSingle
                      ref={c => {
                        this.checkBoxSendSubcontractor = c;
                      }}
                      onChecked={this.onCheckedSendSubcontractor}
                      checked={this.state.isCheckedSendSubcontractor}
                      style={{
                        display: 'inline-block',
                        marginLeft: 15,
                        marginTop: 0
                      }}
                      label='Send this PO to the subcontractor'
                    />
                  </div>
                  <div>
                    <CheckBoxSingle
                      ref={c => {
                        this.checkBoxSendCopy = c;
                      }}
                      onChecked={this.onCheckedSendCopy}
                      checked={this.state.isCheckedSendCopy}
                      style={{
                        display: 'inline-block',
                        marginLeft: 15,
                        marginTop: 0,
                        marginBottom: 5
                      }}
                      label='Send me a copy'
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='rfs-detail add-new-work-order'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Add new purchase order</h2>
        </div>
        <ul className='breadcrumb'>
          <li>
            <Link to={'/punch-lists'}><Translate translateKey='punchlist' capitalize /></Link>
          </li>
          <li>
            <Link to={`/punch-lists/${this.state.rfsId}`}>
              BT #{this.state.rfsId}
            </Link>
          </li>
          <li>
            <Link
              to={`/punch-lists/${this.state.rfsId}/punch-list-item/${
                this.state.workOrderId
              }`}
            >
              WO #{this.state.workOrderId}
            </Link>
          </li>
          <li className='breadcrumb-siteone-li'>Add new purchase order</li>
        </ul>
        {this.renderNewPurchaseOrder()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    costCodeSelectList: state.CostCodeStore.costCodeSelectList,
    workOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
    userProfile: state.UserStore.UserProfile,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
    // ProjectProfile: state.ProjectStore.ProjectProfile,
    LotProfile: state.LotStore.LotProfile
  };
};

export default connect(mapStateToProps)(AddPurchaseOrders);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/add-purchase-order.js